const $inject = ['$scope', '$routeParams', '$filter','dataService', 'settingsService'];

const lbaPolicyCodeSelectCtrl = function ($scope, $routeParams, $filter, dataService, settingsService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  const dataLookUpDataSource = dataService.spiltDataAt(vm.settings.dataSource, $routeParams);
  const policies  = _.get(dataService.data.activeItem, dataLookUpDataSource);  

  vm.selectType = vm.settings.selectType || 'multi';
  vm.refreshPolicies = refreshPolicies;

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function refreshPolicies(userSearch) {
    vm.policies = $filter('filter')(policies, userSearch, false);
  };

};

lbaPolicyCodeSelectCtrl.$inject = $inject;

export default lbaPolicyCodeSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaPolicyCodeSelect/lbaPolicyCodeSelectCtrl.js